<!--扫码揽件 -->
<template>
  <div>
    <van-sticky>
      <div class="tab-sx">
        <div class="item">
          <van-field class="tex" v-model="searchval" placeholder="订单号/ 导购账户 / 寄件人手机号/ 收件人/收件人手机号" />
          <van-button icon="search" class="btn" @click="onSearch"></van-button>
        </div>
        <div class="dv2">
          <FilterItem :display="displayIcon" @onClick="clickTimeIcon" :onFixed="false" height="84"></FilterItem>
        </div>
      </div>
      <van-tabs
        :color="$theme.main_color_btn_bg"
        class="div-tab"
        :border="false"
        :active="active"
        @change="onChange"
        :ellipsis="false"
      >
        <van-tab title="全部成功" name="5"></van-tab> 
        <van-tab title="部分成功" name="4"></van-tab>
        <van-tab title="全部失败" name="3"></van-tab>
        <van-tab title="打印进行中" name="2"></van-tab>
        <van-tab title="已扫码" name="1"></van-tab>
      </van-tabs>
    </van-sticky>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        style="min-height: 93vh"
        v-model="isLoading"
        :finished="finished"
        finished-text="没有更多数据"
        @load="onLoad"
      >
        <div v-for="(item,index) in list" :key="index">
          <expressItem :item.sync="item" :pIndex="index" @callbackShowMoreFun="callbackShowMoreFun"/>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>
<script>
import http from "@/utils/axios";
import expressItem from "@/views/beeorder/components/expressItem";
import FilterItem from "@/components/filter/item";
export default {
  props: {},
  data() {
    return {
      loading: false,
      active: '5',
      searchval:'',
      refreshing: false,
      isLoading: false,
      finished: false,
      list:[],
      pageNum:1,
      pageSize: 20,
      total:0,
      displayIcon:{
        one: {show:false},
        two: {show:false},
        three:{show:false},
        four:{active:false, name:'时间'},
      },
      startTime:'',
      endTime:''
    }
  },
  methods: {
    onChange(tab) {
      this.active = tab
      this.setDefaultInit()
    },
    onRefresh() {
      this.$loading.show()
      setTimeout(() => {
        this.pageNum = 1;
        this.list = [];
        //恢复不是最后一页
        this.finished = false;
        this.onLoad();
      }, 1000);
    },
    onLoad() {
      this.isLoading = true;
      setTimeout(() => {
        if (this.refreshing) {
          this.list = [];
          this.refreshing = false;
        }
      });
      http({
        url: 'order/express/printCode/record',
        method: "POST",
        parmes:{
          status: this.active,
          keyWord:this.searchval.trim(),
          printTimeGt: this.startTime,
          printTimeLt: this.endTime,
          pageIndex: this.pageNum,
          pageSize: this.pageSize
        }
      }).then(rps => {
        this.render(rps)
      }).catch(rps=>{
        this.$loading.hide()
      });
    },
    render(rps){
      if (rps.data.pages == 0) {
        this.finished = true;
      } else {
        if (rps.data.list.length === 0) {
          this.finished = true;
        } else {
          this.finished = false;
          this.pageNum++;
        }
        this.list = this.list.concat(rps.data.list);
        this.list.forEach(element => {
          element.showMore = false;
        });
      }
      this.isLoading = false;
      this.$loading.hide();
    },
    onSearch(){
      if(!this.searchval.trim()){
        this.$toast('请输入关键字查询')
        return
      }
      this.setDefaultInit()
    },
    setDefaultInit(){
      this.$loading.show()
      setTimeout(() => {
        this.pageNum = 1;
        this.list = [];
        this.onLoad();
      }, 200);
    },
    clickTimeIcon(val){
      if(val.type == 'four'){
        this.$filterDrawer({
          list:[
            {
              type: 'input',
              alias: 'timer',
              dateType: 'date'
            }
          ],
          visiblePriceInput: false,
          confirm: res => {
            // console.log("clickTimeIcon -> res", res)
            res.start ? (this.startTime = res.start.time) : (this.startTime = '')
            res.end ? (this.endTime = res.end.time) : (this.endTime = '')
            this.displayIcon['four'].active = res.state
            this.setDefaultInit()
          }
        })
      }
    },
    callbackShowMoreFun(row, val){
      let {pIndex, cIndex} = row;
      this.list.forEach((item, index) => {
        if(index == pIndex){
          this.$set(this.list, index, {
            ...item,
            'showMore': val
          });
        }
      });
    }
  },
  created() {},
  mounted(){},
  components: {expressItem,FilterItem},
};
</script>
<style lang="less" scoped>
.div-tab{
  margin-bottom: 10px;
  border-top: 1PX solid #F2F2F2;
  border-bottom: 1PX solid #F2F2F2;
}
.tab-sx {
  background-color: #ffffff;
  height: 84px;
  font-size: 24px;
  padding: 10px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  /deep/.van-cell{
    padding: 0;
  }
  /deep/.van-field__control {
    width: 540px;
    height: 60px;
    background: #F7F7F7;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    -webkit-appearance: none;
    padding-left: 20px;
    font-size: 20px;
  }
  input{
    -webkit-appearance: none;
  }
  .btn{
    width: 60px;
    height: 60px;
    background: var(--epButtonColor);
    color: var(--epTextColor);
    border-radius: 10px;
    margin-left: -3px;
  }
  .item {
    display: flex;
  }
  .dv2{
    width: 220px;
    // height: 70px;
  }
}
</style>